import * as React from "react";
import { View, StyleSheet, Dimensions, Image } from "react-native";
import { themePattern } from "../../constants/pattern";

const { width, height } = Dimensions.get("window");

export default function Patrocinadores() {
  

  // Patrocinadores : Smart Mobile
  let ifscmini = require("./../../assets/ifscmini.jpg");
  let cepimini = require("./../../assets/cepidmini.jpg");
  let cibfarmini = require("./../../assets/cibfarmini.png");
  let eicmini = require("./../../assets/eicmini.png");
  let fapesp = require("./../../assets/fapesp.png");

  return (
    <View style={styles.main}>
      <View style={styles.container}>
        <View style={styles.item}>
          <Image
            source={ifscmini}
            style={styles.logoImage}
            resizeMode="contain"
          />
        </View>
        <View style={styles.item}>
          <Image
            source={eicmini}
            style={styles.logoImage}
            resizeMode="contain"
          />
        </View>
        <View style={styles.item}>
          <Image
            source={cibfarmini}
            style={styles.logoImage}
            resizeMode="contain"
          />
        </View>
      </View>
      <View style={styles.container}>
        <View style={styles.item}>
          <Image
            source={fapesp}
            style={styles.logoImage}
            resizeMode="contain"
          />
        </View>
        
        <View style={styles.item}>
          <Image
            source={cepimini}
            style={styles.logoImage}
            resizeMode="contain"
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  main: {
    flex: 1,
  },
  container: {
    justifyContent: "space-evenly",
    flexDirection: "row",
    flex: 1,
  },
  item: {
    flex: 1,
    padding: 5,
  },
  logoImage: {
    width: "auto",
    height: "100%",
  },
});
